import { attributes, Events } from '@type-r/models';
import { Linked, useLinked, useModel } from '@type-r/react';
import { asCurrency, CollapsableSection, CompactSelect, Option, CompactTextArea, Input, PopupIODialog, ReadOnly, SelectFile, CompactInput, TilesList, Flex } from 'lqx-react';
import * as React from 'react';
import { InmatchPermission } from 'api';
import { Payment, InvoiceMatch } from 'src/app/pages/inmatch/api';
import { MatchLabel, RemittanceAdviceIcon, RowH2Bold } from '../../../../../../common/inmatch';
import { Delta } from './delta';
import { InlinePaymentHeader } from './payment-header';
import { InvoiceRow, ListItem } from './invoicesList';
import { DigitizedIcon, inblockIconStyles } from 'common/invoice-aging';
import { InblockIcon } from 'common/invoice-aging/iconography';
import { Chip } from '@material-ui/core';

const LocalState = attributes({
    comment : String,
    file : null
});

export type ReconciliationStage = 'Approve' | 'Send';

export const ReconcileDialog = ({ $isOpen, payment, stage } : {
    $isOpen : Linked<boolean>,
    payment : Payment,
    stage: ReconciliationStage
}) => {
    const state = useModel( LocalState );
    const matches = payment.matches.filter(m => !!m.invoice || !!m.invoiceNumber);

    return (
        <PopupIODialog
            $isOpen={ $isOpen }
            title={ stage }
            actionLabel={ stage }
            width={800}
            success={ stage === 'Approve' ? 'Reconciliation is approved' : 'Sent' }
            doIO={ async () => {

                await payment.save({ params: { file: state.file, comment: state.comment }});

                await payment.invoices.fetch();
                Events.trigger( "summary:refresh" );
                // TODO: uploads
            }}
        >
            <>
            <ReadOnly.Provider value={ true }>

                <InlinePaymentHeader payment={ payment } isValid={() => payment.isValid()} currency={ payment.currency } />

                <CollapsableSection title={`Matched Invoices - ${ asCurrency( payment.cashApplied, payment.currency )}`}>
                    <TilesList
                        items={ matches }
                        itemSize={ 42 }
                        maxVisibleItemCount={ 5 }
                        renderer={ MatchesTile }
                    />
                </CollapsableSection>

                <Delta payment={ payment } />
            </ReadOnly.Provider>
            <CompactTextArea label="Comments"
                $value={state.$.comment}
            />

            <SelectFile label="Attachment"
                accept=".csv,.edi,.xml,.txt,.json,.pdf,.xls,.doc,.docx,.xlsx,.png,.jpeg,.msg"
                $value={ state.$.file }
            />
            </>
        </PopupIODialog>
    )
}

const MatchesTile = ({ data, style, index }) => {
    const match: InvoiceMatch = data.items[index];
    const iconClasses = inblockIconStyles();
    
    return (
        <div style={style}>
            { match.invoice ? 
                <InvoiceRow key={ match.cid }
                        invoice={match.invoice}
                        compact
                        icon={
                            <DigitizedIcon invoice={ match.invoice }>
                                <MatchLabel type={ match.originType }/>
                            </DigitizedIcon>
                        }
                    >
                        <Input
                            aria-label="Applied Amount"
                            disabled positive number
                            value={ match.appliedAmount }
                        />
                </InvoiceRow> :
                <ListItem
                    icon={
                        <Flex alignCenter>
                            { match.invoiceId ? <InblockIcon src={'/assets/images/inblock_logo.png'} classes={iconClasses} /> : undefined }
                            <RemittanceAdviceIcon />
                        </Flex>
                    }
                    title={ <> <RowH2Bold>{match.invoiceNumber}</RowH2Bold> </>}
                    extensionBox={<></>}
                    
                >
                    <Chip label="Unfunded" variant="outlined" style={{ marginLeft: '10px' }} /> 
                    <Input
                        aria-label="Applied Amount"
                        disabled positive number
                        value={ match.appliedAmount }
                    />
                </ListItem>
            }
        </div>
    );
};


